import { Divider, Grid, useMediaQuery } from '@mui/material'
import React from 'react'
import GlobalPageHeaderText from '../../utility/globalPageHeaderText'
import GlobalButton from '../../utility/globalButton/button' 
import globalStyles from "../../../assets/styles/global.module.scss";
import headerStyles from '../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss'
import KnowledgeBase from './components/knowledgeBase'; 
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { useKnowledgeBaseStore } from '../../../store/knowledgeBaseStore';

const KnowledgeBaseGlobal = () => {
    
    const smallScreen = useMediaQuery('(max-width : 600px) and (min-width : 0px)');  
    const setFlagUploadKnowledgeBaseFilePopup = useKnowledgeBaseStore((state) => state.setFlagUploadKnowledgeBaseFilePopup);

    return (
        <>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={`${globalStyles.fullwidth} ${headerStyles.templateWrapper}`}>
                <Grid container sx={{ padding: { xs: "15px 0px", sm: "23px 0px" } }} direction={"column"} flexWrap={"nowrap"}>
                    <Grid item xs={12} sm={12}>
                        <Grid container sx={{ alignItems: "center" }} direction={"column"}>
                            <Grid item className={globalStyles.fullwidth} sx={{ padding: { xs: "0px 20px", lg: "5px 25px 0px 27px" } }}>
                                <GlobalPageHeaderText
                                    mainHeadText={"Knowledge Base"}
                                    flagMainTextOnly 
                                    actionBlock={
                                        !smallScreen && 
                                        <GlobalButton
                                            buttonText="Upload Knowledge Base"
                                            className='primaryButtonStyle'
                                            startIcon={<FileUploadIcon />}
                                            sx={{ width: "230px" }}
                                            onClick={() => setFlagUploadKnowledgeBaseFilePopup(true)}
                                        />
                                    }
                                />
                                {!smallScreen && <Divider className={`${globalStyles.fullwidth} ${globalStyles.dividerStyles} ${headerStyles.dividerStyle}`} sx={{ paddingTop: "15px !important" }} />}
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={12} sx={{ padding: "25px 25px 0 27px" }}>
                        <KnowledgeBase />
                    </Grid>

                </Grid>
            </Grid>
        </>
    )
}

export default KnowledgeBaseGlobal
